import client from "./client";

export function getUsers() {
  return client.get("/api/users/").then((res) => res.data);
}

export function getUser(id) {
  return client.get(`/api/users/${id}/`).then((res) => res.data);
}

export function addUser(body) {
  return client.post("/api/users/", body).then((res) => res.data);
}

export function setUser(body) {
  return client.put(`/api/users/${body.id}/`, body).then((res) => res.data);
}

export function deleteUser(body) {
  return client.delete(`/api/users/${body.id}/`).then((res) => res.data);
}
